import React, { createContext, useContext, useState, useEffect, useRef } from 'react';
import { socket } from '@/components/navegacao/socket';

interface AtendimentoNotificacoesContextType {
    notificacoesAtendimento: number;
    setNotificacoesAtendimento: React.Dispatch<React.SetStateAction<number>>;
    filaAtendimento: number;
}

const AtendimentoNotificacoesContext = createContext<AtendimentoNotificacoesContextType | undefined>(undefined);

export const AtendimentoNotificacoesProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [notificacoesAtendimento, setNotificacoesAtendimento] = useState(0);
    const [filaAtendimento, setFilaAtendimento] = useState(0);
    const listenersRegistered = useRef(false);

    useEffect(() => {
        // Evita registrar os listeners múltiplas vezes
        if (listenersRegistered.current) return;
        listenersRegistered.current = true;

        console.log('Registrando listeners de notificações de atendimento');

        socket.on('atendimento:contador:sync', (data) => {
            console.log('atendimento:contador:sync', data);
            setNotificacoesAtendimento(data.total || 0);
            if (data.filaTotal !== undefined) setFilaAtendimento(data.filaTotal);
        });

        return () => {
            console.log('Removendo listeners de notificações de atendimento');
            socket.off('atendimento:contador:sync');
            listenersRegistered.current = false;
        };
    }, []);

    return (
        <AtendimentoNotificacoesContext.Provider value={{ notificacoesAtendimento, setNotificacoesAtendimento, filaAtendimento }}>
            {children}
        </AtendimentoNotificacoesContext.Provider>
    );
};

export const useAtendimentoNotificacoes = () => {
    const context = useContext(AtendimentoNotificacoesContext);
    if (context === undefined) {
        throw new Error('useAtendimentoNotificacoes must be used within an AtendimentoNotificacoesProvider');
    }
    return context;
};
